import { Factory } from "@/data/dao/Factory";
import { DiscountsDao } from "@/data/dao/service/DiscountsDao";
import type { IDiscount } from "@/data/model/Discount";
import { Format } from "@/data/util/Format";

import { logError } from "@/shared/logging/errors";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { DiscountForm } from "@/portal/forms/DiscountForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class DiscountController extends BaseTabbedController<IDiscount> {
    private discountForm: DiscountForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(DiscountsDao));

        this.discountForm = new DiscountForm(this.formContentByTabName("discount-edit"));
        this.discountForm.onSaved = (model) => {
            try {
                this.model = model;
                this.discountForm.setFormData(model);
            } catch (err) {
                logError(err);
            }
        };
        this.registerModelForm(this.discountForm);
    }

    protected onModelLoaded(model?: IDiscount) {
        if (model === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }
        this.discountForm.setData(model);
    }
}
